import { createTheme } from '@material-ui/core/styles';
import overrides from '../override';
import { colors, fonts } from './variables';
import { IS_ADMIN } from '../../constants/validation';

const defaultTheme = createTheme();

//create config for colors;
const theme = createTheme({
  palette: {
    primary: {
      main: colors.PRIMARY_MAIN,
      contrastText: colors.PRIMARY_CONTRAST,
      border: colors.PRIMARY_BORDER,
    },
    secondary: {
      main: colors.SECONDARY_MAIN,
      contrastText: colors.WHITE,
    },
    grey: { color: colors.DAILY_LOG_GRAPH_BORDER },
    background: {
      default: colors.PRIMARY_MAIN,
    },
    error: {
      main: colors.RED,
    },
    warning: {
      main: colors.WARNING,
    },
    leftMenuText: {
      color: colors.PRIMARY_CONTRAST,
      fontSize: '14px',
      textDecoration: 'none',
      paddingTop: '2px',
    },
    fontFamily: fonts,
    bodyFontSize: '15px',
    bodySmallFontSize: '16px',
    backgroundColor: '#fff',
    contentStyle: {
      minHeight: '100vh',
      padding: IS_ADMIN ? '0% 3% 3% 3%' : '2% 2% 3.5% 2%',
      backgroundColor: colors.PRIMARY_MAIN,
    },
    contentlogsStyle: {
      minHeight: '100vh',
      padding: '0',
      paddingTop: '2%',
      backgroundColor: colors.PRIMARY_MAIN,
    },
  },
  colors: { ...colors },
  overrides: {
    ...(IS_ADMIN ? overrides : {}),
    MuiExpansionPanelDetails: {
      root: {
        padding: '16px 16px 0px 16px',
      },
    },
    MuiButtonBase: {
      root: {
        disabled: true,
      },
    },
    MuiTableSortLabel: {
      root: {
        color: colors.SECONDARY_MAIN + ' !important',
        '&:hover': {
          color: colors.SECONDARY_MAIN + ' !important',
        },
      },
      iconDirectionDesc: {},
      active: {
        color: colors.SECONDARY_MAIN + ' !important',
      },
      icon: {
        color: colors.SECONDARY_MAIN + ' !important',
      },
    },
    MuiTableRow: {
      root: {
        backgroundColor: colors.BACKGROUND,
        color: colors.PRIMARY_CONTRAST,
        '&:hover': {
          backgroundColor: colors.BACKGROUND,
        },
      },
    },
    MuiSvgIcon: { root: { fontSize: '145.5%' } },
    MuiTable: {
      root: {
        border: '1px solid ' + colors.PRIMARY_BORDER,
      },
    },
    MuiTypography: {
      body1: {
        color: colors.PRIMARY_CONTRAST,
        fontSize: '14px',
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: 'none',
      },
    },
    MuiInput: {
      root: {
        width: '100%',
        color: colors.PRIMARY_CONTRAST,
        height: '40px',
        borderRadius: '3px',
        backgroundColor: colors.PRIMARY_MAIN + '!important',
        fontSize: '16px',
        marginBottom: IS_ADMIN ? '8px' : '18px',
        '&:active': {
          border: '1px solid' + colors.SECONDARY_MAIN,
        },
        '&:focus': {
          border: '1px solid' + colors.SECONDARY_MAIN,
        },
        border: '1px solid ' + '#ccc' + '!important',
      },
    },
    MuiInputBase: {
      input: {
        color: colors.PRIMARY_CONTRAST,
        '&::placeholder': {
          ...(IS_ADMIN ? {} : { color: '#868e96' }),
          fontSize: '15px',
          opacity: '0.5',
          fontWeight: '400',
        },
        '&:active': {
          border: IS_ADMIN ? `1px solid ${colors.SECONDARY_MAIN} !important` : `1px solid ${colors.INPUT_FOCUS}`,
          borderRadius: '3px',
        },
        '&:focus': {
          border: IS_ADMIN ? `1px solid ${colors.SECONDARY_MAIN} !important` : `1px solid ${colors.INPUT_FOCUS}`,
          borderRadius: '3px',
        },
        ...(IS_ADMIN
          ? {
              border: '1px solid ' + 'rgba(255, 255, 255, 0.3)' + '!important',
              backgroundColor: colors.PRIMARY_MAIN + '!important',
            }
          : {}),
      },
    },
    MuiTableCell: {
      head: {
        color: colors.WHITE,
      },
      paddingCheckbox: {
        color: colors.PRIMARY_MAIN + ' !important',
      },
      body: {
        backgroundColor: colors.BLACK,
        color: colors.PRIMARY_CONTRAST,
        borderBottom: '.5px solid ' + colors.PRIMARY_MAIN,
        fontSize: '17px',
      },
    },
    MuiIconButton: {
      root: {
        color: colors.SECONDARY_MAIN,
      },
    },
    MuiButton: {
      root: {
        color: colors.WHITE,
        backgroundColor: colors.SECONDARY_MAIN,
        // padding: '0px!important'
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      xsm: 320,
      sm: 450,
      smd: 481,
      md: 768,
      mlg: 960,
      lg: 1024,
      xl: 1280,
      xxl: 1366,
    },
  },

  typography: {
    body1: {
      color: colors.PRIMARY_CONTRAST,
      fontSize: '14px',
      textTransform: 'none',
    },
    body2: {
      fontSize: '14px',
    },
    h1: {
      fontSize: '20px',
      color: colors.PRIMARY_CONTRAST,
      [defaultTheme.breakpoints.up('sm')]: {
        fontSize: '24px',
      },
    },
    h2: {
      fontSize: '18px',
      color: colors.SECONDARY_MAIN,
      [defaultTheme.breakpoints.up('sm')]: {
        fontSize: '22px',
      },
    },
    backgroundColor: colors.PRIMARY_MAIN,
    fontFamily: fonts,
    color: colors.PRIMARY_CONTRAST,
    subtitle1: {
      fontSize: '16px',
      [defaultTheme.breakpoints.between('sm', 'md')]: {
        fontSize: '18px',
      },
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '25px',
      },
    },
  },
});

export default theme;
